// extracted by mini-css-extract-plugin
export default {"loadMoreWrapper":"LeaseTable_loadMoreWrapper__P7NpY","tableWrapper":"LeaseTable_tableWrapper__BCspM"};